module.exports = __webpack_public_path__ + "img/logo.d7272120.png";